import React, { useEffect, useRef, useState } from "react";
import BuilderTabs from "../../Layouts/BuilderTabs";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import { operatorForActivityPerfomedLogic } from "../../Pages/StateMachine/Activity/Settings/ActivitySettings";
import { hasOwn, mapArrayToObject } from "../../commonFunctions/arrayFunc";
import { useTableContext } from "../../context/TableContext";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import BasicStyleEditor from "../BuilderComponents/BasicStyleEditor";
import ButtonActionIcon from "../BuilderComponents/ButtonActionIcon";
import CustomCss from "../BuilderComponents/CustomCss";
import FieldSelectorFromPopup from "../BuilderComponents/FieldSelectorFromPopup";
import SingleJobPopup from "../BuilderComponents/JobConfigration/SingleJobPopup";
import PreFilterJoinedBy from "../BuilderComponents/PreFilters/PreFilterJoinedBy";
import PreFilterTable from "../BuilderComponents/PreFilters/PreFilterTable";
import { columnOperatorData, operatorData } from "../BuilderComponents/PreFilters/operatorData";
import { AddAndDeleteInlineIcon } from "../BuilderComponents/Preview/IconPreview";
import TableTreeModal from "../BuilderComponents/TableTreeModal";
import ClassSelectorLayout from "../ClassSelectorLayout/ClassSelectorLayout";
import Button from "../FormComponents/Button";
import Input from "../FormComponents/Input";
import Label from "../FormComponents/Label";
import MultiSelectBox from "../FormComponents/MultiSelectBox";
import SingleSelectBox from "../FormComponents/SingleSelectBox";
import Textarea from "../FormComponents/Textarea";

const EditButtonConfig = ({
  editElementRightsidebar,
  onSave,
  places = "",
  smId,
  device,
  type = "statemachine",
  flag = false,
  handleClasses
}) => {
  const [buttonConfig, setButtonConfig] = useState(editElementRightsidebar.config);
  const templateObject = {};
  const [allJobs, setAllJobs] = useState([]);

  const updateClassAndInlineStyle = (data) => {
    onSave({ ...buttonConfig, className: data.classData, inline_style: data.inlineData });
    setButtonConfig({ ...buttonConfig, className: data.classData, inline_style: data.inlineData });
  };

  const [appliedClasses, setAppliedClasses] = useState([]);

  const fetchJobs = async () => {
    let elementType = editElementRightsidebar.type;
    if (elementType === "rv_action_button") elementType = "button";
    if (elementType === "rv_action_dropdown") elementType = "dropdown";
    const { data } = await axiosInstance.get(`/jobs/filter/?places=${places}&elements=${elementType}`);
    setAllJobs(data);
  };

  const fetchAllTemplatesAndJobs = async () => {
    try {
      await fetchJobs();
    } catch (error) {
      handleApiError(error);
    }
  };

  // function filterKeys(keysToFilter) {
  //   return keysToFilter.filter((key) => fieldRef.current.hasOwnProperty(key));
  // }
  // function filterActionKeys(config) {
  //   const data = JSON.parse(JSON.stringify(config));
  //   const actionTypes = ["action_start", "action_end"];
  //   const actions = ["refresh", "show", "hide"];

  //   for (const actionType of actionTypes) {
  //     for (const action of actions) {
  //       data[actionType][action] = filterKeys(data[actionType][action]);
  //     }
  //   }
  //   return data;
  // }

  useEffect(() => {
    fetchAllTemplatesAndJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (flag) {
      if (editElementRightsidebar?.baseElement) {
        setAppliedClasses(editElementRightsidebar?.baseElement?.classes);
      } else {
        setAppliedClasses(editElementRightsidebar?.config?.classes || []);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editElementRightsidebar.id, flag]);

  useEffect(() => {
    if (flag && appliedClasses) {
      handleClasses(appliedClasses, editElementRightsidebar?.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appliedClasses, flag]);

  return (
    <BuilderTabs
      contentClass="button_config_inside"
      tabs={[
        {
          label: "Style",
          content: (
            <div>
              {/*<div className="mb_4">*/}
              {/*  {editElementRightsidebar.baseElement && (*/}
              {/*    <PreviewElementPosition dimentions={editElementRightsidebar.baseElement.style} />*/}
              {/*  )}*/}
              {/*</div>*/}
              <ButtonStyles
                buttonConfig={buttonConfig}
                setButtonConfig={(newconf) => {
                  onSave(newconf);
                  setButtonConfig(newconf);
                }}
              />
              {!flag ? (
                <div className="form_basic_field_wrapper sidebar-edit-option-outer" style={{ padding: "0px" }}>
                  <BasicStyleEditor
                    value={{
                      classData: buttonConfig?.className || {},
                      inlineData: buttonConfig?.inline_style || {}
                    }}
                    callbackFunction={updateClassAndInlineStyle}
                    fieldType={buttonConfig?.type || ""}
                  />
                </div>
              ) : (
                <div>
                  <ClassSelectorLayout
                    defaultSelected={appliedClasses}
                    onChange={setAppliedClasses}
                    type={editElementRightsidebar.type}
                  />
                </div>
              )}
            </div>
          )
        },
        {
          label: "Action",
          content: (
            <ButtonActions
              buttonConfig={buttonConfig}
              setButtonConfig={(newconf) => {
                onSave(newconf);
                setButtonConfig(newconf);
              }}
              smId={smId}
              device={device}
              type={type}
              templateObject={templateObject}
              allJobs={allJobs}
              elements={editElementRightsidebar.elements}
            />
          )
        },
        {
          label: "Advanced",
          content: (
            <ButtonAdvanceStyle
              buttonConfig={buttonConfig}
              setButtonConfig={(newconf) => {
                onSave(newconf);
                setButtonConfig(newconf);
              }}
            />
          )
        }
      ]}
    />
  );
};

export const ButtonDisplayLogic = ({ buttonConfig, setButtonConfig, smId, tableObj, type }) => {
  const displayLogic = buttonConfig.display_logic || { logics: [] };

  const [statemachineData, setStatemachineData] = useState(null);
  const [rdbmsData, setRdbmsData] = useState(null);
  const [apiCalled, setApiCalled] = useState(false);
  const addLogic = () => {
    const newObj = JSON.parse(JSON.stringify(buttonConfig));

    const obj = {
      logic_type: "",
      logic_data: []
    };
    const oldLogicsArray = newObj.display_logic?.logics || [];
    const newDisplayLogic = {
      ...newObj.display_logic,
      logics: [...oldLogicsArray, obj]
    };
    newObj.display_logic = newDisplayLogic;
    setButtonConfig(newObj);
  };

  const fetchStateMachineData = async () => {
    let { data: smData } = await axiosInstance.get(`/state-machine/${smId}`);
    smData = smData.config;
    const { data: rdbms } = await axiosInstance.get(`/rdbms`);
    const groupRdbms = rdbms.filter((rdbms) => rdbms.is_group);

    const { result: groupRdbmsMap } = mapArrayToObject(groupRdbms);
    const { result: states } = mapArrayToObject(smData.states);
    const { result: activities } = mapArrayToObject(smData.activities);

    setStatemachineData({
      states: states,
      activities: activities
    });
    setRdbmsData(groupRdbmsMap);
  };
  useEffect(() => {
    const fetchData = async () => {
      if (displayLogic.logics.length > 0 && !apiCalled) {
        if (smId && type === "statemachine") {
          await fetchStateMachineData();
        }
        setApiCalled(true); // Prevent further API calls
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayLogic.logics.length]);
  return (
    <>
      <div className="d_flex gap_3 mb_2 justify_between">
        <Label className="font_weight_bold">Display Logic</Label>
        <Button variant="secondary" onClick={addLogic}>
          + Add
        </Button>
      </div>
      <div className="builder_form">
        {displayLogic.logics &&
          displayLogic.logics.length > 0 &&
          statemachineData &&
          displayLogic.logics.map((_, index) => (
            <SingleDisplayLogic
              key={buttonConfig.id}
              buttonConfig={buttonConfig}
              setButtonConfig={setButtonConfig}
              index={index}
              statemachineData={statemachineData}
              rdbmsData={rdbmsData}
              smId={smId}
              tableObj={tableObj}
            />
          ))}
      </div>
    </>
  );
};

// const SingleDisplayLogic = ({ buttonConfig, setButtonConfig, index, statemachineData, rdbmsData, smId, tableObj }) => {
//   const [multiSelectOptions, setMultiselectOptions] = useState([]);
//   const [isFieldOpen, setIsFieldOpen] = useState();
//   const { logic_type, logic_data, group_list, rdbms_matching_field } = buttonConfig.display_logic.logics[index];

//   const updateMultiSelectOptions = (type) => {
//     const options =
//       type === "state_base"
//         ? Object.values(statemachineData.states)
//         : type === "activity_performed"
//           ? Object.values(statemachineData.activities)
//           : type === "rdbms_groups"
//             ? Object.values(rdbmsData)
//             : [];
//     setMultiselectOptions(options);
//   };

//   const changeLogicType = (value) => {
//     updateMultiSelectOptions(value);

//     const updatedConfig = {
//       ...buttonConfig,
//       display_logic: {
//         ...buttonConfig.display_logic,
//         logics: buttonConfig.display_logic.logics.map((logic, i) =>
//           i === index ? { logic_type: value, logic_data: [] } : logic
//         )
//       }
//     };
//     setButtonConfig(updatedConfig);
//   };
//   const changeRdbmsGroups = (value) => {
//     const updatedConfig = {
//       ...buttonConfig,
//       display_logic: {
//         ...buttonConfig.display_logic,
//         logics: buttonConfig.display_logic.logics.map((logic, i) =>
//           i === index ? { ...logic, group_list: value } : logic
//         )
//       }
//     };
//     setButtonConfig(updatedConfig);
//   };
//   const updateRdbmsMatchingField = (data) => {
//     const updatedConfig = {
//       ...buttonConfig,
//       display_logic: {
//         ...buttonConfig.display_logic,
//         logics: buttonConfig.display_logic.logics.map((logic, i) =>
//           i === index ? { ...logic, rdbms_matching_field: data.id } : logic
//         )
//       }
//     };
//     setButtonConfig(updatedConfig);
//     setIsFieldOpen(false);
//   };

//   const getSelectedLogicData = useMemo(() => {
//     if (logic_type === "state_base") {
//       return logic_data.map((id) => statemachineData.states[id] || id);
//     }
//     if (logic_type === "activity_performed") {
//       return logic_data.map((id) => statemachineData.activities[id] || id);
//     }
//     if (logic_type === "rdbms_groups") {
//       return logic_data.map((id) => rdbmsData[id] || id);
//     }
//     return [];
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [logic_data, logic_type, statemachineData, rdbmsData]);

//   const deleteLogic = () => {
//     const updatedConfig = {
//       ...buttonConfig,
//       display_logic: {
//         ...buttonConfig.display_logic,
//         logics: buttonConfig.display_logic.logics.filter((_, i) => i !== index)
//       }
//     };
//     setButtonConfig(updatedConfig);
//   };

//   const handleChangeInMultiselect = (data) => {
//     const IDs = data.map((item) => item.id);
//     const updatedConfig = {
//       ...buttonConfig,
//       display_logic: {
//         ...buttonConfig.display_logic,
//         logics: buttonConfig.display_logic.logics.map((logic, i) =>
//           i === index ? { ...logic, logic_data: IDs } : logic
//         )
//       }
//     };
//     setButtonConfig(updatedConfig);
//   };

//   const logicTypeOptions = [
//     { id: "state_base", name: "State Base" },
//     { id: "activity_performed", name: "Activity Performed" },
//     { id: "rdbms_groups", name: "Rdbms Group" },
//     { id: "instance_based", name: "Instance Data Based" }
//   ];
//   useEffect(() => {
//     if (logic_type) {
//       updateMultiSelectOptions(logic_type);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   return (
//     <div className="d_flex gap_2 bg_light p_2 mb_1">
//       <div className="builder_form w_100">
//         <SingleSelectBox
//           selectedData={logic_type}
//           options={logicTypeOptions}
//           onChange={(obj) => changeLogicType(obj.id)}
//           placeholder="Select Logic Type"
//         />
//         <MultiSelectBox
//           options={multiSelectOptions}
//           selectedData={getSelectedLogicData}
//           onChange={handleChangeInMultiselect}
//         />
//         {logic_type === "rdbms_groups" && (
//           <>
//             <Textarea value={group_list} onChange={(e) => changeRdbmsGroups(e.target.value)} />
//             <div className="builder_input d_flex align_center justify_center" onClick={() => setIsFieldOpen(true)}>
//               {!rdbms_matching_field
//                 ? "No field assign"
//                 : (tableObj[rdbms_matching_field]?.activity_label || "") +
//                   "." +
//                   tableObj[rdbms_matching_field]?.display}
//             </div>
//           </>
//         )}
//       </div>
//       <ButtonActionIcon type="delete" onClick={deleteLogic} />
//       <BuilderModal
//         isOpen={isFieldOpen}
//         onClose={() => setIsFieldOpen(false)}
//         modalName={"Select Rdbms Matching Field"}
//       >
//         <TableTreeModal callbackFunction={updateRdbmsMatchingField} tableId={smId} />
//       </BuilderModal>
//     </div>
//   );
// };

const SingleDisplayLogic = ({ buttonConfig, setButtonConfig, index, statemachineData, rdbmsData, smId, tableObj }) => {
  const { logic_type } = buttonConfig.display_logic.logics[index];

  const logicTypeOptions = [
    { id: "state_base", name: "State Base" },
    { id: "activity_performed", name: "Activity Performed" },
    { id: "rdbms_groups", name: "Rdbms Group" },
    { id: "instance_based", name: "Instance Data Based" }
  ];

  const updateLogicData = (newData) => {
    const updatedConfig = {
      ...buttonConfig,
      display_logic: {
        ...buttonConfig.display_logic,
        logics: buttonConfig.display_logic.logics.map((logic, i) => (i === index ? { ...logic, ...newData } : logic))
      }
    };
    setButtonConfig(updatedConfig);
  };

  const deleteLogic = () => {
    const updatedConfig = {
      ...buttonConfig,
      display_logic: {
        ...buttonConfig.display_logic,
        logics: buttonConfig.display_logic.logics.filter((_, i) => i !== index)
      }
    };
    setButtonConfig(updatedConfig);
  };

  return (
    <div className="d_flex gap_2 bg_light p_2 mb_1">
      <div className="builder_form w_100">
        <SingleSelectBox
          selectedData={logic_type}
          options={logicTypeOptions}
          onChange={(obj) => updateLogicData({ logic_type: obj.id, logic_data: [] })}
          placeholder="Select Logic Type"
        />

        {/* Render logic-type-specific component */}
        {logic_type === "state_base" && (
          <StateBaseSelector
            buttonLogic={buttonConfig.display_logic.logics[index]}
            statemachineData={statemachineData}
            onChange={updateLogicData}
          />
        )}
        {logic_type === "activity_performed" && (
          <ActivityPerformedSelector
            buttonLogic={buttonConfig.display_logic.logics[index]}
            statemachineData={statemachineData}
            onChange={updateLogicData}
          />
        )}
        {logic_type === "rdbms_groups" && (
          <RdbmsGroupSelector
            buttonLogic={buttonConfig.display_logic.logics[index]}
            rdbmsData={rdbmsData}
            tableObj={tableObj}
            smId={smId}
            onChange={updateLogicData}
          />
        )}
        {logic_type === "instance_based" && (
          <InstanceDataSelector
            buttonLogic={buttonConfig.display_logic.logics[index]}
            onChange={updateLogicData}
            smId={smId}
          />
        )}
      </div>

      <ButtonActionIcon type="delete" onClick={deleteLogic} />
    </div>
  );
};

const StateBaseSelector = ({ buttonLogic, statemachineData, onChange }) => {
  const options = Object.values(statemachineData.states);
  const selectedData = (buttonLogic.logic_data || []).map((id) => statemachineData.states[id] || id);

  return (
    <MultiSelectBox
      options={options}
      selectedData={selectedData}
      onChange={(data) => onChange({ logic_data: data.map((d) => d.id) })}
    />
  );
};

const ActivityPerformedSelector = ({ buttonLogic, statemachineData, onChange }) => {
  const options = Object.values(statemachineData.activities);
  const selectedData = (buttonLogic.logic_data || []).map((id) => statemachineData.activities[id] || id);

  return (
    <MultiSelectBox
      options={options}
      selectedData={selectedData}
      onChange={(data) => onChange({ logic_data: data.map((d) => d.id) })}
    />
  );
};

const RdbmsGroupSelector = ({ buttonLogic, rdbmsData, tableObj, smId, onChange }) => {
  const [isFieldOpen, setIsFieldOpen] = useState(false);
  const options = Object.values(rdbmsData);

  const selectedData = (buttonLogic.logic_data || []).map((id) => rdbmsData[id] || id);

  return (
    <>
      <MultiSelectBox
        options={options}
        selectedData={selectedData}
        onChange={(data) => onChange({ logic_data: data.map((d) => d.id) })}
      />
      <Textarea value={buttonLogic.group_list || ""} onChange={(e) => onChange({ group_list: e.target.value })} />
      <div className="builder_input d_flex align_center justify_center" onClick={() => setIsFieldOpen(true)}>
        {!buttonLogic.rdbms_matching_field
          ? "No field assign"
          : (tableObj[buttonLogic.rdbms_matching_field]?.activity_label || "") +
            "." +
            (tableObj[buttonLogic.rdbms_matching_field]?.display || "")}
      </div>

      <BuilderModal isOpen={isFieldOpen} onClose={() => setIsFieldOpen(false)} modalName="Select Rdbms Matching Field">
        <TableTreeModal
          tableId={smId}
          callbackFunction={(data) => {
            onChange({ rdbms_matching_field: data.id });
            setIsFieldOpen(false);
          }}
        />
      </BuilderModal>
    </>
  );
};

const InstanceDataSelector = ({ buttonLogic, onChange, smId }) => {
  const [rule, setRuleState] = useState(buttonLogic.rules || { field: "", operator: "", value: "" });
  const [arrayText, setArrayText] = useState(
    Array.isArray(buttonLogic.rule?.value) ? buttonLogic.rule?.value.join(",") : ""
  );

  const setRule = (newRule) => {
    setRuleState(newRule);
    onChange({ rules: newRule });
  };

  const handleArrayChange = (e) => {
    setArrayText(e.target.value);
  };

  const commitArrayValue = () => {
    setRule({
      ...rule,
      value: arrayText
        .split(",")
        .map((v) => v.trim())
        .filter((v) => v !== "")
    });
  };

  const handleNormalChange = (e) => {
    setRule({
      ...rule,
      value: e.target.value.trim()
    });
  };

  return (
    <div className="gap_2">
      <div className="d_flex flex_column gap_2 align_center">
        <FieldSelectorFromPopup
          tableId={smId}
          tableType="statemachine"
          onSelect={(fieldObj) => setRule({ field: fieldObj?.id, operator: "", value: "" })}
          fieldId={rule.field}
        />
        <SingleSelectBox
          options={operatorForActivityPerfomedLogic}
          valueKey="id"
          labelKey="label"
          selectedData={rule.operator}
          onChange={(op) => setRule({ ...rule, operator: op.id })}
          isSearch
          placeholder="Select Operator"
        />
        {["in", "intersects", "subset"].includes(rule.operator) ? (
          <Input
            type="text"
            value={arrayText}
            onChange={handleArrayChange}
            onBlur={commitArrayValue}
            placeholder="comma,separated,values"
            style={{ padding: "6px", width: "100%" }}
            disabled={!rule.operator}
          />
        ) : (
          <Input
            type="text"
            value={rule.value}
            onChange={handleNormalChange}
            placeholder={rule.operator === "contains" ? "Enter value to check in array" : "Enter value"}
            style={{ padding: "6px", width: "100%" }}
            disabled={!rule.operator}
          />
        )}
      </div>
    </div>
  );
};

const EditActionSelector = ({ type, buttonConfig, setButtonConfig, fieldRef }) => {
  const [selectedActions, setSelectedActions] = useState({
    refresh: false,
    show: false,
    hide: false
  });

  const handleActionChange = (action) => {
    setSelectedActions((prevState) => ({
      ...prevState,
      [action]: !prevState[action]
    }));
  };

  const handleDefaultActions = (action, list) => {
    const newObj = JSON.parse(JSON.stringify(buttonConfig));
    newObj[type][action] = list.map((item) => item.id);
    setButtonConfig(newObj);
  };

  const getSelectedDataAccordingToAction = (action) => {
    try {
      const actionIds = buttonConfig?.[type]?.[action];
      const fields = fieldRef?.current;

      if (!Array.isArray(actionIds) || !fields) return [];

      return actionIds
        .map((id) => {
          const field = fields[id];
          if (!field || !field.name) return null;
          return { id, name: field.name };
        })
        .filter(Boolean); // Remove any nulls
    } catch {
      return [];
    }
  };

  const formatType = (text) => {
    return text
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  useEffect(() => {
    const updatedActions = JSON.parse(JSON.stringify(selectedActions));
    ["refresh", "show", "hide"].forEach((action) => {
      if (buttonConfig[type]?.[action]?.length > 0) {
        updatedActions[action] = true;
      }
    });
    setSelectedActions(updatedActions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="builder_form">
      <Label className="builder_label">
        <strong>{formatType(type)}</strong>
      </Label>

      {["refresh", "show", "hide"].map((action) => (
        <div key={action} style={{ marginBottom: "10px" }}>
          <Input
            type="checkbox"
            checked={selectedActions[action]}
            onChange={() => handleActionChange(action)}
            label={action}
          />

          {selectedActions[action] && (
            <div style={{ marginTop: "10px" }}>
              <MultiSelectBox
                selectedData={getSelectedDataAccordingToAction(action)}
                options={Object.values(fieldRef.current) || []}
                placeholder={`Select to ${action}`}
                onChange={(list) => handleDefaultActions(action, list)}
              />
            </div>
          )}
        </div>
      ))}

      {/* Add Refresh Time Input Field for Action End */}
      {type === "action_end" && (
        <div className="builder_form">
          <Label>Refresh Time (milliseconds)</Label>
          <Input
            type="number"
            value={buttonConfig.refresh_time || ""}
            onChange={(e) => {
              const value = parseInt(e.target.value);
              const updatedConfig = { ...buttonConfig, refresh_time: value };
              setButtonConfig(updatedConfig);
            }}
            placeholder="Enter refresh time in milliseconds"
          />
        </div>
      )}
    </div>
  );
};

export const ButtonStyles = ({ buttonConfig, setButtonConfig }) => {
  const handleChangeLabel = (e) => {
    let updatedConfig = { ...buttonConfig };
    updatedConfig.name = e.target.value;
    setButtonConfig(updatedConfig);
  };
  const callbackFunction = (data) => {
    let updatedConfig = { ...buttonConfig };
    updatedConfig.icon = data;
    setButtonConfig(updatedConfig);
  };

  return (
    <div className="builder_form">
      <Label>Button Label</Label>
      <div className="d_flex icon-and-btn-wrap">
        <AddAndDeleteInlineIcon icon={buttonConfig.icon || ""} callbackFunction={(data) => callbackFunction(data)} />
        <Input inputClassName="border_left_none outline_none" value={buttonConfig.name} onChange={handleChangeLabel} />
      </div>
    </div>
  );
};

const ButtonAdvanceStyle = ({ buttonConfig, setButtonConfig }) => {
  const handleCustomCss = (e) => {
    let updatedConfig = { ...buttonConfig };

    const { name, value } = e.target;
    updatedConfig[name] = value;
    setButtonConfig(updatedConfig);
  };

  return (
    <CustomCss
      value={{
        custom_css: buttonConfig.custom_css || "",
        custom_id: buttonConfig.custom_id || "",
        custom_classname: buttonConfig.custom_classname || ""
      }}
      onChange={handleCustomCss}
    />
  );
};

const ButtonActions = ({
  buttonConfig,
  setButtonConfig,
  allJobs,
  smId,
  device,
  type,
  templateObject = {},
  elements
}) => {
  const { getTableTypeData } = useTableContext();
  const [tableObj, setTableObj] = useState({});
  const fieldRef = useRef({});

  const handleChangeActionOnChange = (e) => {
    let updatedConfig = { ...buttonConfig };
    updatedConfig.action_call_onchange = e.target.checked;
    setButtonConfig(updatedConfig);
  };

  const updateButtonConfig = (name, value) => {
    let updatedConfig = { ...buttonConfig };
    updatedConfig[name] = value;
    setButtonConfig(updatedConfig);
  };

  const handleChangeButtonConfig = (data) => {
    let updatedConfig = { ...buttonConfig };
    updatedConfig = { ...data };
    setButtonConfig(updatedConfig);
  };

  const handleChangeButtonJobConfig = (data) => {
    let updatedConfig = { ...buttonConfig };
    updatedConfig.job_id = data.job_id;
    updatedConfig.params = data.params;
    updatedConfig.job_template = data.job_template;
    setButtonConfig(updatedConfig);
  };
  useEffect(() => {
    if (type && smId) {
      const fetchTable = async () => {
        try {
          const { tableObject } = await getTableTypeData(type, smId);
          setTableObj(tableObject);
        } catch (error) {
          console.error("Error fetching table data:", error);
        }
      };
      fetchTable();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [smId, type]);

  useEffect(() => {
    elements?.forEach((field) => {
      fieldRef.current[field.id] = field;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="builder_form">
        <ButtonStyles buttonConfig={buttonConfig} setButtonConfig={handleChangeButtonConfig} />
        <SingleJobPopup
          config={{
            job_id: buttonConfig.job_id || "",
            params: buttonConfig.params || {},
            job_template: buttonConfig.job_template || ""
          }}
          onChange={handleChangeButtonJobConfig}
          allJobs={allJobs}
          smId={smId}
          device={device}
          type={type}
          templateObject={templateObject}
          label="Assign Job"
        />
      </div>
      {hasOwn(buttonConfig, "action_call_onchange") && (
        <Input
          label="Action call on change"
          type="checkbox"
          checked={buttonConfig.action_call_onchange}
          onChange={handleChangeActionOnChange}
          containerClassName="mb_3"
        />
      )}
      {smId && smId !== "appuser" && (
        <div className="mb_4">
          <PreFilterJoinedBy
            prefiltersJoinedBy={buttonConfig.pre_filters_join_by}
            setPrefiltersJoinedBy={(value) => updateButtonConfig("pre_filters_join_by", value)}
          />
          <PreFilterTable
            preFilters={buttonConfig?.pre_filters || []}
            setPreFilters={(value) => updateButtonConfig("pre_filters", value)}
            tableId={smId}
            operatorList={[...operatorData, ...columnOperatorData]}
            tableObj={tableObj}
          />
        </div>
      )}
      {smId && smId !== "appuser" && (
        <ButtonDisplayLogic
          buttonConfig={buttonConfig}
          setButtonConfig={handleChangeButtonConfig}
          smId={smId}
          tableObj={tableObj}
          type={type}
        />
      )}
      {elements.length > 0 && (
        <div className="mb_2">
          <EditActionSelector
            type="action_start"
            buttonConfig={buttonConfig}
            setButtonConfig={handleChangeButtonConfig}
            fieldRef={fieldRef}
          />
        </div>
      )}
      {elements.length > 0 && (
        <EditActionSelector
          type="action_end"
          buttonConfig={buttonConfig}
          setButtonConfig={handleChangeButtonConfig}
          fieldRef={fieldRef}
        />
      )}
    </>
  );
};

export default EditButtonConfig;
export { ButtonActions };
